<template>
  <div class="swiper swiper-container">
    <div class="swiper-wrapper">
      <div v-for="(image, id) in images" :key="id" class="swiper-slide">
        <img :src="image">
      </div>
    </div>
    <div v-if="mode == 'full'" class="swiper-button-prev"><Icon icon="arr-left" /></div>
    <div v-if="mode == 'full'" class="swiper-button-next"><Icon icon="arr-right" /></div>
  </div>
</template>

<script>
/* eslint-disable import/order */
import Vue from 'vue'
import Component from 'vue-class-component'

import 'swiper/dist/css/swiper.css'
import SwiperLib from 'swiper'

import Icon from '@/components/Icon'

@Component({
  components: {
    Icon,
  },
  props: {
    mode: {
      type: String, // 'full', 'preview'
      required: false,
      default: () => 'full',
    },
    images: {
      type: Array,
      required: true,
    },
    initialSlide: {
      type: Number,
      required: false,
      default: () => 0,
    },
  },
})
export default class Swiper extends Vue {
  mounted () {
    this.initializeSwiperForMode(this.mode)
  }

  destroyed () {
    if (this.swiper) {
      this.swiper.destroy()
    }
  }

  initializeSwiperForMode (mode) {
    const initializers = {
      full: this.initFullMode,
      preview: this.initPreviewMode,
    }

    if (initializers[mode]) {
      initializers[mode]()
    } else {
      throw new Error(`Unknown mode '${mode}'`)
    }
  }

  initFullMode () {
    this.swiper = new SwiperLib(this.$el, {
      loop: true,
      images: this.images,
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      initialSlide: this.initialSlide,
      on: {
        click: () => { this.$emit('selected', { index: this.swiper.realIndex }) },
      },
    })
  }

  initPreviewMode () {
    this.swiper = new SwiperLib(this.$el, {
      loop: true,
      loopedSlides: 0,
      loopFillGroupWithBlank: true,
      images: this.images,
      slidesPerView: 3,
      spaceBetween: 5,
      initialSlide: this.initialSlide,
      slideToClickedSlide: true,
      on: {
        click: () => this.$emit('selected', { index: this.swiper.realIndex }),
      },
    })
  }
}
</script>

<style lang="scss">
.swiper-container {
  background-color: transparent;
  @include media(desktop) {
    position: static;
  }

  img {
    width: 100%;
  }
}
.swiper-button-prev,
.swiper-button-next {
  position: absolute;

  @include media(tablet) {
    transform: translateY(-50%);
    margin-top: -10px;
  }
  
  .figure {
    font-size: 45px;
  }
}
.swiper-button-prev {
  @include media (tablet) {
    left: 15px;
  }

  @include media (desktop) {
    left: -45px;
  }
}
.swiper-button-next {
  @include media (tablet) {
    right: 15px;
  }

  @include media (desktop) {
    right: -45px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/offers-list/Swiper.vue